export const disallowedThemePacksEditing = ['amethyst', 'bold', 'classic', 'fun'];
